import "@expert/theme/global.css";

import { GlobalNotificationProvider, ToastProvider } from "@expert/common-ui";
import { ContentfulClientProvider } from "@expert/contentful";
import { getLogger } from "@expert/logging";
import { initAppcues, initFullStory } from "@expert/monitoring";
import { GlobalThemeProvider } from "@expert/theme";
import { RootAnalyticsProvider } from "@soluto-private/eventualize-react";
import { FeedbackContextProvider } from "@soluto-private/expert-workspace-feedback";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createClient } from "contentful";
import { type JSX, useEffect } from "react";
import { RouterProvider } from "react-router";
import { env } from "@/config";
import { transformDispatcher } from "./analytics";
import { router } from "./router";
import { enhanceAnalytics } from "./utils";

const logger = getLogger({ module: "App" });
window.addEventListener("unhandledrejection", ({ reason }: { reason: unknown }) => {
    logger.error({ err: reason }, "unhandledrejection");
});

const queryClient = new QueryClient({ defaultOptions: { queries: { gcTime: 1000 * 60 * 60 /* 1 hour */ } } });

const contentfulClient = createClient(env.contentful);

export default function App(): JSX.Element {
    useEffect(() => {
        transformDispatcher((dispatcher) => {
            return dispatcher.withEnhancer(enhanceAnalytics);
        });
        initFullStory({
            orgId: env.fullstoryOrgId,
            isDevMode: !env.fullstoryEnabled,
        });
        initAppcues({
            isEnabled: env.appcuesEnabled,
            url: env.appcuesUrl,
            appName: env.appName,
            channel: env.channel,
        });
    }, []);

    return (
        <GlobalThemeProvider>
            <RootAnalyticsProvider>
                <ContentfulClientProvider client={contentfulClient}>
                    <QueryClientProvider client={queryClient}>
                        <GlobalNotificationProvider>
                            <ToastProvider>
                                <FeedbackContextProvider expertFeedbackUrl={env.expertFeedbackUrl}>
                                    <RouterProvider router={router} />
                                </FeedbackContextProvider>
                            </ToastProvider>
                        </GlobalNotificationProvider>
                    </QueryClientProvider>
                </ContentfulClientProvider>
            </RootAnalyticsProvider>
        </GlobalThemeProvider>
    );
}
